export const negligible = 0.0001;
export const defaultRobots = [
    { name: 'red', hat: 0xFF0000, },
    { name: 'blue', hat: 0x0000FF, },
    { name: 'green', hat: 0x00FF00, },
];
